import { LocalizedValue } from '@app/models/shared.models';

export function resolveNameTitleCodeForSelect(
  raw: string | null | undefined,
  nameTitles: readonly LocalizedValue[],
): string | null {
  if (raw == null || raw === '') return null;
  const s = String(raw).trim();
  if (s === '') return null;
  if (nameTitles.some((t) => t.code === s)) return s;
  const byId = nameTitles.find((t) => t.id === s);
  return byId?.code ?? s;
}
